import { render, staticRenderFns } from "./ChatSearchPage.vue?vue&type=template&id=41fd4ae7&scoped=true"
import script from "./ChatSearchPage.vue?vue&type=script&lang=js"
export * from "./ChatSearchPage.vue?vue&type=script&lang=js"
import style0 from "./ChatSearchPage.vue?vue&type=style&index=0&id=41fd4ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd4ae7",
  null
  
)

export default component.exports